module.exports = __webpack_public_path__ + "img/gat_way3_norms_img.e4b07b3d.png";